import React, { useEffect, useContext } from 'react'
import LoadingOverlay from 'react-loading-overlay'
import { Card, CardBody, Table, Button } from 'reactstrap'
import ApptSysContext from './ApptSysContext'

const ApptSysList = ({ onAdd, onEdit }) => {
    const { loading, apptSystems, loadApptSystems } = useContext(ApptSysContext)

    useEffect(() => {
        loadApptSystems()
    }, [])

    const maskQueueUrl = (url) => {
        if (!url) return '-';        
        const match = url.match(/amazonaws\.com\/(\d+)\//);
        if (match && match[1]) {
            const number = match[1];
            if (number.length > 2) {
                const masked = number[0] + '*' + number[number.length - 1];
                return url.replace(number, masked);
            }
        }
        return url;
    }

    return (
        <LoadingOverlay active={loading} spinner>
            <Card className='p-3'>
                <div className="mb-3">
                    <h6 className='text-primary'>System List</h6>
                </div>
                <CardBody className="p-0">
                    <Card className="mt-2 mb-3">
                        <CardBody className="p-3">
                            {apptSystems && apptSystems.length > 0 ? (
                                <div className="react-table">
                                    <Table bordered hover responsive>
                                        <thead className="table-light table-nowrap" style={{ fontFamily: 'Inter, Poppins, sans-serif',
                                                fontSize: '13px', lineHeight: '19.5px' }} >
                                            <tr>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        System Name
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        Integration Type
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        Scope
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        System Group
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        Request Queue
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        System Attributes
                                                    </div>
                                                </th>
                                                <th>
                                                    <div className="mb-2" style={{ fontWeight: '600' }}>
                                                        Actions
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {apptSystems.map((system, index) => (
                                                <tr key={system.system_id || index}>
                                                    <td>{system.system_nm}</td>
                                                    <td>{system.integ_type}</td>
                                                    <td>{system.appt_sys_scope}</td>
                                                    <td>{system.system_grp}</td>
                                                    <td className="text-break" style={{maxWidth: '250px'}}>
                                                        {maskQueueUrl(system.req_queue)}
                                                    </td>
                                                    <td>
                                                        <div style={{maxWidth: '200px', maxHeight: '100px', overflow: 'auto'}}>
                                                            <pre style={{
                                                                fontSize: '11px',
                                                                margin: 0,
                                                                whiteSpace: 'pre-wrap',
                                                                wordBreak: 'break-word'
                                                            }}>
                                                                {system.sys_attrbs ? 
                                                                    (() => {
                                                                        try {
                                                                            return JSON.stringify(JSON.parse(system.sys_attrbs), null, 2);
                                                                        } catch (e) {
                                                                            return system.sys_attrbs;
                                                                        }
                                                                    })()
                                                                    : '-'
                                                                }
                                                            </pre>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <Button color="link" className="p-0" onClick={() => onEdit(system)} title="Edit">
                                                            <i className="bx bx-edit" style={{ fontSize: '18px' }} />
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            ) : (
                                <div style={{ textAlign: 'center', padding: '40px' }}>
                                    <h6>No systems found</h6>
                                    <Button color="primary" onClick={onAdd} className="mt-2">
                                        Add First System
                                    </Button>
                                </div>
                            )}
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </LoadingOverlay>
    )
}

export default ApptSysList